// Ukrainian

export default {

  component: {
    jobAdList: {
      title: 'Відкриті вакансії',
      jobs: 'посади',
      noJobAds: 'На цей момент, немає жодних відкритих вакансій.',
    },

    jobAdCard: {
      openUntil: date => `Відкрита до ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Дякуємо.',
      readyInfo: 'Ми отримали Вашу заявку. Рекрутер зв’яжеться з Вами найближчим часом.',
      luck: 'Бажаємо успіхів!',
    },

    jobAdSeeYou: {
      title: 'Дякуємо.',
      description: 'Ваша заявка збережена і ми відправили посилання, щоб ви змогли продовжити її пізніше.',
    },

    unpublished: {
      title: 'Неопубліковано',
      info: 'Оголошення про роботу ще не опубліковано.',
    },
  },

  page: {},

}
